import { AndDoneJSEnvironment, FragmentURL, HubURL } from '../types/config.types';

export const AJS_FRAGMENT_URLS = {
  local: 'http://localhost:4200',
  development: 'https://fragments.dev.anddone.com',
  uat: 'https://fragments.uat.anddone.com',
  production: 'https://fragments.anddone.com',
} as const satisfies Record<AndDoneJSEnvironment, FragmentURL>;

export const AJS_HUB_URLS = {
  local: 'http://localhost:5196',
  development: 'https://fragments-hub.dev.anddone.com',
  uat: 'https://fragments-hub.uat.anddone.com',
  production: 'https://fragments-hub.anddone.com',
} as const satisfies Record<AndDoneJSEnvironment, HubURL>;

export const DEFAULT_PAYMENT_METHOD = 'card';
